module.exports = __webpack_public_path__ + "static/media/icon_gps.eac28422.svg";